import { useCallback, useEffect, useMemo, useState } from "react";
import { Grid } from "@mui/material";
import ContentTitle from "../../../../components/Content/ContentTitle";
import { INavigationLink } from "../../../../interfaces/INavigation";
import { useUserContext } from "../../../../contexts/UserContext";
import { useLanguageContext } from "../../../../contexts/LanguageContext";
import ReportsData from '../../../../data/Reports';
import DefaultConstants from "../../../../data/Constants";
import IReport from '../../../../interfaces/IReport';
import { useReportPreviewContext } from '../../../../contexts/ReportPreviewContext';
import IUser from '../../../../interfaces/IUser';
import FormHelper from '../../../../helpers/FormHelper';
import UserService from '../../../../services/UserService';
import IAccessProfile from '../../../../interfaces/IAccessProfile';
import AccessProfileService from '../../../../services/AccessProfileService';
import DataCard from '../../../../components/DataCard';
import useDialog from "../../../../hooks/useDialog";


const Reports = (linkProps: INavigationLink) => {
    const { translate } = useLanguageContext();
    const { user, enterprise, userPermissions } = useUserContext();
    const { handleOpen } = useReportPreviewContext();

    const [selectedReport, setSelectedReport] = useState<IReport | undefined>(undefined);
    const filtersDialog = useDialog();

    const [userList, setUserList] = useState<IUser[]>([]);
    const [accessProfileList, setAccessProfileList] = useState<IAccessProfile[]>([]);
    
    
    const reportList = useMemo(() => {
        return ReportsData.filter(r => userPermissions.includes(r.alias));
        // eslint-disable-next-line
    }, [userPermissions]);


    const enterpriseList = useMemo(() => {
        return user?.enterprises.filter(e => e.permissions.map(p => p.alias).includes(selectedReport?.alias ?? '')) ?? [];
    }, [user, selectedReport]);


    useEffect(() => {
        if (userList.length === 0) {
            const formData = FormHelper.Create(undefined);
            UserService.List(formData)
                .then((resp) => {
                    setUserList(resp.data.users as IUser[]);
                });
        }

        if (accessProfileList.length === 0) {
            const formData = FormHelper.Create(undefined);
            AccessProfileService.List(formData)
                .then((resp) => {
                    setAccessProfileList(resp.data.accessProfiles as IAccessProfile[]);
                });
        }
        // eslint-disable-next-line
    }, []);


    const handleChangeSelectedReport = useCallback((report: IReport) => {
        setSelectedReport(report);
        filtersDialog.handleOpen();
        // eslint-disable-next-line
    }, []);


    const handleOpenPreview = useCallback((report: IReport, filters: any) => {
        handleOpen(report, filters);
        // eslint-disable-next-line
    }, []);


    return (
        <>
            <Grid item xs={12} className='grid-header'>
                <Grid item className='grid-title'>
                    <ContentTitle
                        name={translate(linkProps.name)} 
                        description={enterprise?.name}
                        applyTranslation={false}
                    />
                </Grid>
            </Grid>

            <Grid container
                className='grid-content overflow-enabled justifycontent-flexstart aligncontent-flexstart' 
                rowSpacing={DefaultConstants.gridRowSpacing} 
                columnSpacing={DefaultConstants.gridColumnSpacing}
            >
                {
                    reportList.map(report => {
                        return <Grid item lg={3} md={4} sm={6} xs={12} key={report.alias}>
                            <DataCard 
                                variant='default'
                                variantProps={{
                                    default: {
                                        title: translate(report.title),
                                        subtitle: report.subtitle ? translate(report.subtitle) : undefined
                                    }
                                }}
                                Icon={report.Icon}
                                onClick={() => handleChangeSelectedReport(report)}
                            />
                        </Grid>;
                    })
                }
            </Grid>

            {
                selectedReport && <selectedReport.Filters 
                    open={filtersDialog.open}
                    handleClose={() => filtersDialog.handleClose()}
                    handleOpenPreview={(filters: any) => handleOpenPreview(selectedReport, filters)}
                    enterpriseList={enterpriseList}
                    userList={userList}
                    accessProfileList={accessProfileList}
                />
            }
        </>
    );
}

export default Reports;